// extracted by mini-css-extract-plugin
module.exports = {"tag":"PotentialProfileTag_tag__Idv4x"};